import React from 'react'
import Page from '../Page'

const CS = ({ testResult }) => {
  return (
    <>
      <Page
        testResult={testResult}
        title="معرفی الگوی رفتاری CS وظیفه‌گرا و ثبات‌گرا"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری  CS ترکیبی از دقت، نظم، وظیفه‌شناسی و آرامش هستند. آن‌ها معمولاً افرادی محتاط، صبور و تحلیل‌گر به شمار می‌روند که از بی‌نظمی، فشارهای ناگهانی و تصمیم‌گیری‌های شتاب‌زده فاصله می‌گیرند. شخصیت آن‌ها بیشتر به دنبال ثبات، امنیت، کیفیت بالا و احترام به چارچوب‌ها و قوانین است.
        </p>
        <p className="text-gray-800 leading-7">
          ویژگی شاخص آن‌ها چیست؟
          توجه وسواس‌گونه به جزئیات، پایبندی به استانداردها و رویکرد محافظه‌کارانه در برابر تغییرات.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="این افراد در موقعیت‌های مختلف چگونه عمل می‌کنند؟"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>در محیط‌های ساختاریافته، شفاف و قابل پیش‌بینی بهترین عملکرد را دارند.</li>
          <li>دوست ندارند در مرکز توجه باشند، ولی به شدت روی کیفیت و نتیجه دقیق کار تمرکز می‌کنند.</li>
          <li>کارهای ناتمام، بی‌برنامه یا پرهیجان، برای آن‌ها استرس‌آور است.</li>
          <li>در روابط اجتماعی، به جای شور و هیجان، به آرامش، تعهد، صداقت و قابل اعتماد بودن اهمیت می‌دهند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت این الگو:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>وجدان کاری بالا</li>
          <li>رعایت دقیق چارچوب‌ها و نظم</li>
          <li>دقت در تحلیل، مشاهده و تصمیم‌گیری</li>
          <li>وفاداری و ثبات در روابط حرفه‌ای و فردی</li>
          <li>توانایی در پیاده‌سازی استانداردهای کیفی در کار</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های رایج CSها:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>مقاومت در برابر تغییر</li>
          <li>وسواس در جزئیات</li>
          <li>کند بودن در تصمیم‌گیری‌های فوری</li>
          <li>تمایل به تأیید دیگران قبل از اقدام</li>
          <li>ترس از اشتباه کردن یا قضاوت شدن</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فرض کنید در یک تیم کاری، پروژه‌ای نیازمند طراحی دقیق یک فرآیند ایمنی است. فردی با الگوی  CS ممکن است:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>بارها جزئیات را بازبینی کند،</li>
          <li>گزارش‌های کامل و دقیق آماده کند،</li>
          <li>از روش‌های قدیمی استفاده کند مگر اینکه اطمینان کامل از روش جدید حاصل شود،</li>
          <li>اما اگر تیم بخواهد تصمیمی سریع بگیرد، او به زمان بیشتری برای تحلیل نیاز دارد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاد فیلم:"
      >
        <p className="text-gray-800 leading-7">
          The Imitation Game  2014
          شخصیت آلن تورینگ به‌عنوان فردی دقیق، منطقی، محتاط و کمال‌گرا، نمونه‌ای الهام‌بخش از رفتار  CS را نمایش می‌دهد. تماشای این فیلم می‌تواند در درک الگوی  CS بسیار مؤثر باشد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری CS"
      >
        <p className="text-gray-800 leading-7">
          الگوی رفتاری  CS  وظیفه‌گرا - ثبات‌گرا  ترکیبی از دو بُعد مهم در مدل  DISC است.
          این افراد بیش از هر چیز به دقت، نظم، تداوم و روابط آرام و پیش‌بینی‌پذیر اهمیت می‌دهند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تفکر ساختاریافته و منطقی</h3>
        <p className="text-gray-800 leading-7">
          افراد  CS تمایل دارند اطلاعات را با دقت بالا بررسی کنند، همه جوانب را بسنجند و از تصمیم‌گیری عجولانه اجتناب کنند.
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>با ذهنی تحلیلی، منظم و ساختارگرا به دنیا نگاه می‌کنند.</li>
          <li>از خطا یا اشتباه، حتی کوچک، هراس دارند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. ثبات رفتاری و قابل پیش‌بینی بودن</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>این افراد تغییرات ناگهانی را دوست ندارند و از بی‌نظمی و هیاهو دوری می‌کنند.</li>
          <li>رفتارشان معمولاً آرام، باثبات و مبتنی بر احترام متقابل است.</li>
          <li>علاقه‌مندند در محیطی کار کنند که قوانین مشخص و چارچوب‌های روشن دارد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. تعهد به کار و مسئولیت‌پذیری</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>اگر کاری به آن‌ها سپرده شود، با نهایت دقت و احساس مسئولیت انجام می‌دهند.</li>
          <li>به هیچ عنوان اهل رها کردن پروژه‌ها یا بدقولی نیستند.</li>
          <li>کارهای نیمه‌تمام یا غیرکیفی باعث استرس جدی آن‌ها می‌شود.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. نیاز به تأیید و بازخورد مثبت</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>آن‌ها دوست دارند بدانند عملکردشان مطابق با انتظارات است.</li>
          <li>از بازخورد صادقانه اما مؤدبانه استقبال می‌کنند.</li>
          <li>اگر احساس کنند مورد نقد یا قضاوت ناعادلانه قرار گرفته‌اند، به شدت عقب‌نشینی می‌کنند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. گوش دادن فعال، اما محافظه‌کاری در ابراز نظر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS شنونده‌های بسیار خوبی هستند،</li>
          <li>اما تا زمانی که مطمئن نباشند حرفشان دقیق، منطقی و بی‌اشتباه است، کمتر وارد بحث می‌شوند.</li>
          <li>در موقعیت‌های اجتماعی ممکن است کم‌حرف به نظر برسند، اما دقیقاً همان کسی هستند که به خوبی تحلیل می‌کند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ترجیح به کار مستقل یا در گروه‌های کوچک و هماهنگ</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>در تیم‌هایی با ارتباطات زیاد، هیجان بالا یا تغییرات سریع، زود خسته می‌شوند.</li>
          <li>اما در گروه‌های با هدف روشن، قوانین مشخص و رفتارهای پیش‌بینی‌پذیر، درخشان ظاهر می‌شوند.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال ملموس:
          تصور کنید قرار است برای شرکت، یک سامانه ثبت اطلاعات طراحی شود. فرد  CS :
          ابتدا چند روز را صرف بررسی نیازها، قوانین و محدودیت‌ها می‌کند،
          سپس برنامه‌ای دقیق و گام‌به‌گام ارائه می‌دهد،
          و در طول کار، بارها جزئیات را بررسی و بازبینی می‌کند تا هیچ خطایی باقی نماند.
          این دقت، اگر در تعادل باشد، سرمایه‌ای فوق‌العاده برای هر تیم است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تشریح الگوی رفتاری CS"
      >
        <p className="text-gray-800 leading-7">
          در این بخش، می‌خواهیم الگوی  CS را از سه زاویه‌ی مهم و مکمل تحلیل کنیم:
          شناختی  چطور فکر می‌کند ، هیجانی  چطور احساس می‌کند  و رفتاری  چطور عمل می‌کند  تا تصویر کامل‌تری از این شخصیت به‌دست آید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="1. عملکرد شناختی سبک فکری"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS ساختارگرا، تحلیل‌گر و منطقی هستند.</li>
          <li>تمایل دارند داده‌ها را دسته‌بندی کرده، بررسی کنند و بر اساس شواهد تصمیم بگیرند.</li>
          <li>به تصمیمات بدون بررسی و رفتارهای هیجانی مشکوک‌اند.</li>
          <li>به قواعد، روندها، قوانین و مستندات اهمیت می‌دهند.</li>
          <li>ذهن آن‌ها بیشتر روی "درست انجام دادن" متمرکز است تا "سریع انجام دادن".</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="2. عملکرد هیجانی سبک عاطفی"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>عموماً آرام، متین و دارای احساسات عمیق هستند.</li>
          <li>بروز هیجان در آن‌ها ملایم است. ممکن است ناراحتی یا استرس را به صورت درونی تحمل کنند و آن را نشان ندهند.</li>
          <li>از برخوردهای مستقیم، تحقیر یا بی‌احترامی به شدت آسیب می‌بینند، حتی اگر چیزی نگویند.</li>
          <li>احساس ارزشمندی آن‌ها وابسته به میزان دقت و کیفیت کاری است که انجام می‌دهند.</li>
          <li>به فضای آرام، صمیمی و قابل پیش‌بینی نیاز دارند تا امنیت هیجانی‌شان حفظ شود.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="3. عملکرد رفتاری سبک عمل و واکنش"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>آهسته، دقیق، گام‌به‌گام پیش می‌روند.</li>
          <li>از روش‌های آزموده و موفق قبلی استفاده می‌کنند، مگر آن‌که با دلیل و تحلیل به این نتیجه برسند که باید تغییر دهند.</li>
          <li>در محیط‌های پرتنش یا ناپایدار، معمولاً عقب‌نشینی می‌کنند و منتظر می‌مانند تا وضعیت به تعادل برسد.</li>
          <li>خیلی اهل نمایش یا تبلیغ خود نیستند، اما نتایج کارشان بسیار حرفه‌ای و قابل اتکاست.</li>
          <li>وقتی مسئولیتی را می‌پذیرند، با تعهد کامل پیش می‌روند، حتی اگر شرایط سخت شود.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط طلایی این تیپ رفتاری:"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">ویژگی مثبت</th>
                <th className="border border-gray-300 p-3 font-semibold">اگر افراط شود</th>
                <th className="border border-gray-300 p-3 font-semibold">چالش احتمالی</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">دقت بالا</td>
                <td className="border border-gray-300 p-3">وسواس در جزئیات</td>
                <td className="border border-gray-300 p-3">کندی در عمل</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">وفاداری</td>
                <td className="border border-gray-300 p-3">وابستگی افراطی</td>
                <td className="border border-gray-300 p-3">ناتوانی در "نه" گفتن</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">نظم و ساختار</td>
                <td className="border border-gray-300 p-3">مقاومت در برابر تغییر</td>
                <td className="border border-gray-300 p-3">ناتوانی در سازگاری سریع</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">فروتنی</td>
                <td className="border border-gray-300 p-3">کاهش عزت‌نفس</td>
                <td className="border border-gray-300 p-3">نادیده گرفتن توانمندی خود</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          در یک جلسه‌ی تیمی که بحث درباره تغییر نرم‌افزار سازمانی است، افراد  CS ابتدا ساکت می‌مانند، بعد از بررسی کامل نظرات و ابعاد، با مستندات مشخص موضع خود را اعلام می‌کنند. ممکن است با تغییر موافق باشند، اما فقط اگر داده‌های دقیق و دلایل کافی ببینند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Bridge of Spies"  2015  پل جاسوس ها با بازی تام هنکس
          شخصیتی دقیق، آرام، با عزت نفس بالا که در شرایط بحرانی، با تعهد، استدلال و خونسردی فوق‌العاده مسائل را مدیریت می‌کند. این شخصیت نماد یک  CS متعادل و مؤثر است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="انگیزه‌های رفتاری افراد با الگوی CS"
      >
        <p className="text-gray-800 leading-7">
          افراد  CS  وظیفه‌گرا-ثبات‌گرا  از جمله افرادی هستند که انگیزه‌های آن‌ها اغلب به درونشان مربوط می‌شود، نه محرک‌های بیرونی. آن‌ها بیشتر با حس مسئولیت، دقت و میل به آرامش و پیش‌بینی‌پذیری برانگیخته می‌شوند تا با هیجان یا رقابت.
        </p>
        <p className="text-gray-800 leading-7">
          در این بخش، عوامل انگیزشی اصلی افراد  CS را با تمرکز بر انگیزه‌های درونی، بیرونی و موانع انگیزشی بررسی می‌کنیم.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="1. انگیزه‌های درونی افراد CS"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">انجام درست و دقیق کارها:</h4>
            <p>
              آن‌ها از انجام کارهای دقیق، با کیفیت بالا و مطابق استاندارد لذت می‌برند. انجام بی‌نقص وظایف برای‌شان احساس ارزشمندی می‌آورد.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">حس آرامش، ثبات و امنیت:</h4>
            <p>
              محیط‌های بدون تنش، قابل پیش‌بینی و سازمان‌یافته، به آن‌ها انرژی می‌دهد. تغییرات سریع یا پیش‌بینی‌ناپذیر باعث استرسشان می‌شود.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">شناخته شدن به عنوان فردی دقیق، حرفه‌ای و وفادار:</h4>
            <p>
              افراد  CS نیاز دارند بدانند که دیگران آن‌ها را به‌عنوان فردی قابل اعتماد، متعهد و منظم می‌شناسند.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">داشتن چارچوب مشخص در فعالیت‌ها:</h4>
            <p>
              آن‌ها در محیط‌هایی که وظایف، قوانین و استانداردها روشن باشند بهتر عمل می‌کنند.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="2. انگیزه‌های بیرونی مؤثر بر افراد CS"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">دریافت بازخورد مثبت محترمانه:</h4>
            <p>
              اگر بدانند تلاش‌شان دیده می‌شود و مورد تقدیر است، انگیزه‌شان تقویت می‌شود.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">امکان داشتن زمان کافی برای انجام دقیق کارها:</h4>
            <p>
              فشارهای زمانی ناگهانی یا تصمیم‌گیری‌های سریع می‌تواند انگیزه‌شان را کاهش دهد.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">احترام از سوی مدیران یا همکاران:</h4>
            <p>
              آن‌ها دوست دارند به‌عنوان فردی قابل اتکا و منظم مورد احترام باشند، نه صرفاً فردی خنثی یا ساکت.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-800 mb-2">پرهیز از رقابت‌های هیجانی:</h4>
            <p>
              آن‌ها معمولاً با فضاهای رقابتی پرهیجان انگیزه نمی‌گیرند، بلکه بیشتر در محیط‌های حمایتی و همکارانه شکوفا می‌شوند.
            </p>
          </div>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="3. موانع انگیزشی چه چیزی انگیزه CS را کاهش می‌دهد؟"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تصمیم‌گیری‌های عجولانه و تغییر مداوم مسیر</li>
          <li>بی‌نظمی در کار، مدیریت ضعیف یا نداشتن دستورالعمل روشن</li>
          <li>بی‌توجهی به تلاش آن‌ها یا دریافت بازخورد منفی بی‌ملاحظه</li>
          <li>قرار گرفتن در نقش‌های نمایشی یا پرریسک</li>
          <li>تضاد و تعارض‌های آشکار در تیم یا خانواده</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فرض کنید فرد  CS مسئول کنترل کیفیت در کارخانه‌ای است. او زمانی بیشترین انگیزه را دارد که:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>فرآیندها مشخص و مستند باشند،</li>
          <li>مدیرش به دقت او اعتماد کند،</li>
          <li>و به خاطر اصلاح یک نقص کوچک، از او تقدیر شود.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          اگر به ناگاه گفته شود که همه استانداردها را کنار بگذارد و «سریع فقط تحویل بده»، انگیزه‌اش به‌شدت افت خواهد کرد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی برای درک عمیق‌تر:"
      >
        <p className="text-gray-800 leading-7">
          "A Beautiful Mind"  2001
          شخصیت جان نش در این فیلم، با دقت، آرامش و تمرکز بر تحلیل، انگیزه درونی خود را از تلاش برای نظم در جهان اطراف می‌گیرد. نمایش خوبی از انگیزش درون‌زای یک شخصیت  CS .
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری  CS معمولاً به عنوان افرادی قابل اعتماد، منظم و حرفه‌ای در محیط کار شناخته می‌شوند. آن‌ها عاشق نظم، دقت، و ثبات در انجام کارها هستند. اما همین ویژگی‌ها گاهی ممکن است سرعت عمل یا انعطاف‌پذیری‌شان را کاهش دهد.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه به بررسی کامل عادت‌های کاری این تیپ رفتاری می‌پردازیم
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. ساختارگرایی و رعایت چارچوب‌ها</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS برای انجام درست کارها نیاز به مسیر شفاف دارند.</li>
          <li>ترجیح می‌دهند ابتدا اطلاعات را کامل جمع‌آوری کنند و بعد اقدام کنند.</li>
          <li>از کارهای مبهم، بی‌برنامه یا با شرح وظایف نامشخص گریزانند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تمرکز بالا بر کیفیت و جزئیات</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>نسبت به خطاهای کوچک هم حساس‌اند و ترجیح می‌دهند کاری نکنند تا اینکه کاری ناتمام یا ناقص انجام دهند.</li>
          <li>در بررسی اسناد، گزارش‌ها، کدها، طرح‌ها یا هر فعالیتی که نیاز به دقت دارد درخشان هستند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. پیش‌بینی‌پذیری و رفتار یکنواخت</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS طبق یک ریتم منظم و مشخص کار می‌کنند.</li>
          <li>کار روزمره‌ی تکراری آن‌ها را خسته نمی‌کند، بلکه برای‌شان اطمینان‌بخش است.</li>
          <li>اگر فرآیندها تغییر زیادی داشته باشند، دچار بی‌انگیزگی یا سردرگمی می‌شوند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تعاملات محدود ولی مؤثر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>در ارتباطات کاری بیشتر شنونده‌اند تا گوینده.</li>
          <li>وارد درگیری‌های غیرضروری نمی‌شوند.</li>
          <li>در محیط‌های آرام، کم‌تنش و محترمانه رشد می‌کنند و از تعارض فراری‌اند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. وابستگی به تأیید و عدم تمایل به اشتباه</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>قبل از انجام یک کار، معمولاً دنبال تأیید نهایی می‌گردند تا مطمئن شوند مسیرشان درست است.</li>
          <li>همین موضوع ممکن است باعث کندی در اجرا یا عدم جسارت در پیشنهاد ایده‌های جدید شود.</li>
          <li>ممکن است برای رفع یک مشکل ساده، چندین راهکار مختلف بررسی کنند، اما دست به اجرا نزنند تا از درست بودن آن مطمئن شوند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="عادت‌های کاری شما در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. ترجیح برای کار فردی یا تیم‌های کم‌تنش</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS دوست دارند خودشان کارشان را با دقت جلو ببرند و نیاز به کمک زیادی از دیگران ندارند.</li>
          <li>اما اگر در تیم باشند، ترجیح می‌دهند در کنار افرادی آرام، منظم و دقیق کار کنند.</li>
          <li>از هیاهو، جلسات شلوغ و مدیریت‌های سلیقه‌ای دوری می‌کنند.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرض کنید یک  CS مسئول مستندسازی فرایند تولید در یک کارخانه است. او:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>به‌جای شروع بلافاصله، ابتدا تمامی داده‌ها را جمع‌آوری می‌کند،</li>
          <li>از مستندات قبلی نسخه‌برداری می‌کند،</li>
          <li>هر مرحله را با دقت یادداشت می‌نماید،</li>
          <li>و فقط پس از بازبینی کامل، آن را نهایی می‌کند.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          او شاید سریع‌ترین نباشد، اما اگر کار را به او بسپارید، می‌توانید با خیال راحت پای آن امضا بزنید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های شما در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          درک دیدگاه‌های درونی افراد  CS نسبت به جهان، دیگران و خودشان، کلید مهمی برای مدیریت ارتباط مؤثر با آن‌هاست. این دیدگاه‌ها، پایه‌ و بنیان رفتار آن‌ها در زندگی شخصی، حرفه‌ای و اجتماعی است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های شما در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. دیدگاه نسبت به خود:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS خود را وظیفه‌شناس، دقیق، باوجدان و محتاط می‌دانند.</li>
          <li>آن‌ها به خودشان افتخار می‌کنند که بدون جلب توجه، کارها را به‌درستی و کامل انجام می‌دهند.</li>
          <li>اما گاهی خود را در تصمیم‌گیری‌های سریع یا تعاملات پرهیجان ناتوان می‌بینند.</li>
          <li>در درون خود همیشه در تلاش برای «کم‌نقص بودن» هستند، و این وسواس می‌تواند گاهی احساس استرس یا نارضایتی درونی ایجاد کند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. دیدگاه نسبت به دیگران:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS به کسانی که با احترام، منطق و نظم رفتار می‌کنند اعتماد می‌کنند.</li>
          <li>افرادی که رفتارهای پرهیجان، بی‌برنامه، یا بی‌توجه به اصول دارند، برای‌شان گیج‌کننده یا غیرقابل پیش‌بینی هستند.</li>
          <li>آن‌ها انتظار دارند دیگران هم مانند خودشان متعهد، صادق و مسئولیت‌پذیر باشند.</li>
          <li>در برابر کسانی که قول می‌دهند ولی عمل نمی‌کنند، به‌شدت بی‌اعتماد می‌شوند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌های شما در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. دیدگاه نسبت به تغییر و نوآوری:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تغییر برای آن‌ها نه هیجان‌انگیز بلکه تهدیدآمیز است.</li>
          <li>در برابر تغییرات بزرگ، اول محتاط و مقاوم هستند، مگر اینکه برای‌شان توضیح منطقی و مرحله‌به‌مرحله داده شود.</li>
          <li>اگر تغییر به خوبی طراحی و مدیریت شود، آن‌ها می‌توانند بهترین اجراکنندگان آن باشند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. دیدگاه نسبت به کار و شغل:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>کار برای افراد  CS فقط انجام یک وظیفه نیست؛ بلکه انجام درست، اخلاقی، دقیق و محترمانه‌ی یک مسئولیت است.</li>
          <li>آن‌ها از رشد آهسته اما مستمر لذت می‌برند.</li>
          <li>به کیفیت کار بیشتر از سرعت یا نتیجه‌ی موقت اهمیت می‌دهند.</li>
          <li>ترجیح می‌دهند در موقعیت‌هایی باشند که وظایف روشن، قوانین مشخص و انتظارات شفاف دارند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. دیدگاه نسبت به زندگی و روابط:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS به آرامش، ثبات، اعتماد و پیش‌بینی‌پذیری در زندگی اهمیت زیادی می‌دهند.</li>
          <li>ترجیح می‌دهند دایره روابط‌شان محدود اما عمیق، صادقانه و قابل اتکا باشد.</li>
          <li>برای‌شان مهم است که مورد احترام واقع شوند، نه صرفاً تحسین.</li>
          <li>زندگی ایده‌آل آن‌ها ترکیبی از تعادل، نظم، کیفیت، احترام و سکوت مؤثر است.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فردی با تیپ  CS که در حال انتخاب شغل جدید است، تا وقتی اطلاعات دقیقی از شرایط محیط، شرح وظایف، فرهنگ سازمانی و ثبات شغلی نداشته باشد، اقدام نمی‌کند. تصمیمش با فکر زیاد، پرس‌وجو، تحقیق و مقایسه صورت می‌گیرد. نه با عجله، نه با احساس.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری  CS در اوقات فراغت نیز همانند محیط کاری، به دنبال آرامش، ساختار، معنا و نظم هستند. آن‌ها برخلاف تیپ‌های پرتحرک و هیجان‌محور، بیشتر به فعالیت‌هایی علاقه دارند که ذهن را درگیر کرده، اما هم‌زمان حس امنیت، دقت و رضایت درونی ایجاد کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. علاقه به فعالیت‌های ساختارمند و آرام</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS معمولاً از فعالیت‌هایی مثل مطالعه، نوشتن، پازل، شطرنج، باغبانی، یا کارهای دستی دقیق لذت می‌برند.</li>
          <li>این فعالیت‌ها به آن‌ها اجازه می‌دهد ذهن خود را متمرکز کنند و در محیطی بدون تنش، احساس مفید بودن داشته باشند.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. لذت از تنهایی هدفمند یا روابط صمیمانه و محدود</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>آن‌ها اغلب از بودن در جمع‌های شلوغ یا مهمانی‌های پرهیاهو پرهیز می‌کنند.</li>
          <li>ترجیح می‌دهند وقت خود را با تعداد محدودی از دوستان نزدیک یا خانواده بگذرانند؛ آن هم در فضایی امن، آرام و کنترل‌شده.</li>
          <li>تنهایی برای‌شان منبع انرژی و تجدید قواست، نه نشانه انزوا.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. علاقه به یادگیری و رشد تدریجی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>اوقات فراغت برای آن‌ها فرصتی برای یادگیری است. ممکن است به دوره‌های آنلاین، خواندن کتاب‌های توسعه فردی، زبان‌آموزی یا حتی مستندسازی تجربیات خود علاقه‌مند باشند.</li>
          <li>در واقع "کیفیت وقت آزاد" برایشان مهم‌تر از "تعداد فعالیت‌ها"ست.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="اوقات فراغت در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. سفرهای کم‌ریسک، با برنامه و آرام</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS اگر اهل سفر باشند، سفرهایی با برنامه‌ریزی دقیق، مکان‌های آرام و طبیعت خلوت را انتخاب می‌کنند.</li>
          <li>آن‌ها اهل سفرهای هیجانی یا ماجراجویی‌های غافلگیرکننده نیستند. برایشان مهم است که از قبل همه چیز را بدانند: مقصد، مسیر، محل اقامت، هزینه‌ها و...</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تمایل به نظم حتی در تفریح</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>حتی در اوقات فراغت، ممکن است برنامه‌ریزی کنند، جدول بزنند، نظم وسایل را مرتب کنند یا بودجه خانوادگی را تنظیم نمایند.</li>
          <li>این رفتارها برای‌شان آرامش‌بخش است، نه محدودکننده.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال ملموس:
          تصور کنید یک فرد  CS برای تعطیلات آخر هفته برنامه‌ریزی می‌کند. او:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>از قبل فهرست وسایل مورد نیاز را می‌نویسد،</li>
          <li>مسیر سفر را بررسی می‌کند،</li>
          <li>رزرو محل اقامت را از چند روز قبل انجام داده،</li>
          <li>و حتی احتمال بارندگی را هم در برنامه‌اش لحاظ می‌کند!</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاد فیلم مرتبط با روحیه آرام و متفکرانه CS :"
      >
        <p className="text-gray-800 leading-7">
          Julie &amp; Julia  2009
          داستان زندگی زنی که با تمرین روزانه‌ی آشپزی از کتاب جولیا چایلد، نظم و ساختار را وارد زندگی روزمره‌اش می‌کند. نمایشی از پیوستگی، نظم، علاقه به جزئیات و رضایت از فرآیند، نه فقط نتیجه.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="تصمیم‌گیری در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          افراد  CS در تصمیم‌گیری معمولاً با دقت و احتیاط بالا عمل می‌کنند. برای آن‌ها، تصمیم‌گیری یعنی بررسی همه جوانب، تحلیل دقیق اطلاعات، گرفتن تأیید، و حرکت در چارچوبی که از اشتباه جلوگیری کند. گرچه این سبک باعث کاهش خطا می‌شود، اما گاهی سرعت عمل را نیز پایین می‌آورد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="1. سبک تصمیم‌گیری: آرام، تحلیل‌گر، مستندگرا"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>قبل از هر تصمیمی، ابتدا اطلاعات جمع‌آوری می‌کنند.</li>
          <li>به شدت دنبال "تصمیم درست و بی‌نقص" هستند، نه صرفاً "تصمیم سریع".</li>
          <li>اگر زمان کافی نداشته باشند یا تصمیم مبهم باشد، دچار تعویق، شک و استرس می‌شوند.</li>
          <li>ترجیح می‌دهند تصمیماتی بگیرند که قابلیت پیش‌بینی نتایج آن بالا باشد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="2. چالش‌های رایج در تصمیم‌گیری:"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">چالش</th>
                <th className="border border-gray-300 p-3 font-semibold">توصیف</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">وسواس در جمع‌آوری اطلاعات</td>
                <td className="border border-gray-300 p-3">تا زمانی که همه جوانب بررسی نشود، شروع نمی‌کنند.</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">ترس از اشتباه</td>
                <td className="border border-gray-300 p-3">بیش از حد به عواقب تصمیم فکر می‌کنند.</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">نیاز به تأیید بیرونی</td>
                <td className="border border-gray-300 p-3">گاهی بدون گرفتن تأیید دیگران، جرات اجرای تصمیم را ندارند.</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">تعارض بین منطق و احساس</td>
                <td className="border border-gray-300 p-3">در مواقعی که دل و عقل در تضادند، قفل می‌شوند.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="3. راهکارها برای بهبود تصمیم‌گیری CSها:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تفکیک تصمیم‌های کوچک از بزرگ: همه تصمیم‌ها به تحلیل عمیق نیاز ندارند. گاهی باید رها کرد و جلو رفت.</li>
          <li>استفاده از بازه زمانی مشخص: برای هر تصمیم، زمانی محدود تعیین شود : «تا فردا ظهر باید نتیجه را اعلام کنم».</li>
          <li>مشورت با افراد با تیپ D  یا I : این افراد کمک می‌کنند تصمیم سریع‌تر و با نگاه ریسک‌پذیرتر اتخاذ شود.</li>
          <li>تمرین نه گفتن و اعتماد به تصمیم شخصی: همیشه نظر دیگران مهم نیست. گاهی باید به تحلیل شخصی اعتماد کرد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="4. مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          فرض کنید یک فرد  CS بین دو پیشنهاد شغلی مردد است. او:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>مزایا و معایب هر دو را می‌نویسد،</li>
          <li>با چند نفر مشورت می‌کند،</li>
          <li>به‌جای نگاه صرف به درآمد، محیط کاری و ثبات را بررسی می‌کند،</li>
          <li>و احتمال دارد تا زمانی که یکی از پیشنهادات از بین نرود، تصمیم نگیرد!</li>
        </ul>
        <p className="text-gray-800 leading-7">
          در چنین مواقعی، اگر با یک فرد  D  نتیجه‌گرا و ریسک‌پذیر هم‌فکری کند، ممکن است سریع‌تر به نتیجه برسد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          Moneyball  2011
          در این فیلم، تحلیل‌گر آماری تیم بیسبال با تصمیم‌گیری‌هایی منطقی و مبتنی بر داده، روش سنتی انتخاب بازیکن را تغییر می‌دهد. مثال خوبی برای تأثیر سبک تصمیم‌گیری محتاط اما داده‌محور.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد CS"
      >
        <p className="text-gray-800 leading-7">
          افراد  CS با دقت، وفاداری و مسئولیت‌پذیری خود سرمایه‌ای ارزشمند در هر سازمان یا خانواده هستند. اما گاهی برخی ویژگی‌های رفتاری مانند وسواس در جزئیات، مقاومت در برابر تغییر و کندی در تصمیم‌گیری می‌تواند مانع پیشرفت یا ارتباط مؤثر آن‌ها شود.
        </p>
        <p className="text-gray-800 leading-7">
          در ادامه مجموعه‌ای از پیشنهادات حرفه‌ای برای ارتقاء عملکرد این افراد ارائه می‌شود:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تمرین برای سرعت‌بخشی در عمل</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>همه تصمیم‌ها نیاز به بررسی عمیق ندارند.</li>
          <li>با تعیین «ضرب‌الاجل درونی» برای کارها  مثل "در ۲۴ ساعت آینده اقدام می‌کنم"  می‌توان اقدام‌محورتر شد.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. رها کردن کمال‌گرایی افراطی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>«کافیِ خوب» در بسیاری از مواقع بهتر از «عالیِ ناتمام» است.</li>
          <li>تمرین کنید پروژه‌ها را قبل از رسیدن به حالت بی‌نقص  در ذهن خودتان  تحویل دهید.</li>
        </ul>
        <p className="italic text-gray-700">
          جمله راهبردی: کار خوب بهتر از کار عالی‌ای است که تمام نشده.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. شجاعت در نشان دادن احساسات و ابراز نظر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>نظر و تحلیل شما ارزشمند است، حتی اگر کامل نباشد.</li>
          <li>در جلسات گروهی، یک جمله ساده مثل: «اگر بخوام یه دیدگاه اولیه بگم...»  می‌تواند آغازگر مشارکت شما باشد.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. ساختن ارتباطات مؤثرتر با تیپ‌های سریع‌تر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>با افراد High D  یا High I  کار می‌کنید؟ سعی کنید از سرعت آن‌ها نرنجد و در مقابل، آن‌ها را با دقت خود حمایت کنید.</li>
          <li>به جای مخالفت یا انزوا، دنبال مکمل بودن باشید.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. بهبود مدیریت زمان و اولویت‌بندی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>به‌جای توجه همزمان به همه جزئیات، از ماتریس «اهمیت-فوریت» استفاده کنید.</li>
          <li>تمرین ساده: هر روز فقط ۳ کار کلیدی را مشخص کرده و حتماً همان‌ها را انجام دهید.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات جهت بهبود عملکرد CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. افزایش جسارت و تمرین “نه” گفتن</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS گاهی به‌خاطر حس مسئولیت زیاد، بی‌دلیل بار دیگران را به دوش می‌کشند.</li>
        </ul>
        <p className="italic text-gray-700">
          جمله تمرینی: «الان واقعاً اولویت دیگه‌ای دارم، اما خوشحال می‌شم بعداً کمک کنم.»
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. رشد آگاهانه در برابر تغییر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تغییر را تهدید ندانید، فرصتی برای یادگیری ببینید.</li>
          <li>برای شروع، فقط «یک تغییر کوچک در هفته» را بپذیرید. مثل استفاده از یک ابزار جدید یا تعامل با یک همکار متفاوت.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی: فرد  CS در موقعیت شغلی حسابرسی است. او:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>به‌خاطر دقت بالا تحسین می‌شود،</li>
          <li>اما گاهی به‌خاطر وسواس در تهیه گزارش نهایی، تحویل پروژه را به تعویق می‌اندازد.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          با اجرای تمرین‌های بالا، می‌آموزد:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>نسخه‌ی اولیه را سریع‌تر تحویل دهد،</li>
          <li>سپس جزئیات را طی بازخوردها بهبود دهد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="رمز موفقیت در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          افراد  CS با ویژگی‌های دقت، نظم و ثبات، در صورتی که بتوانند نقاط ضعف خود را به خوبی مدیریت کنند، به موفقیت‌های بزرگ و ماندگار دست پیدا می‌کنند. رمز موفقیت آن‌ها در این است که این ویژگی‌ها را به نقطه قوت و مزیت رقابتی تبدیل کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکات کلیدی رمز موفقیت CSها:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تمرکز بر کیفیت و دقت در انجام کارها</h3>
        <p className="text-gray-800 leading-7">
          حفظ استانداردهای بالا و دقت در جزئیات، عاملی تعیین‌کننده در کسب اعتماد و اعتبار حرفه‌ای آن‌هاست.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تعهد و پایبندی به برنامه‌ها و اهداف</h3>
        <p className="text-gray-800 leading-7">
          با داشتن نظم و مسئولیت‌پذیری بالا، پروژه‌ها را با کیفیت و در زمان مقرر به پایان می‌رسانند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. آمادگی برای تغییر و پذیرش تدریجی آن</h3>
        <p className="text-gray-800 leading-7">
          یادگیری سازگاری با تغییرات محیطی و حرفه‌ای، رمز موفقیت در دنیای پرشتاب امروز است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکات کلیدی رمز موفقیت CSها:"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تمرین تصمیم‌گیری به موقع و منطقی</h3>
        <p className="text-gray-800 leading-7">
          تلاش برای جلوگیری از وسواس در تصمیم‌گیری و ایجاد تعادل بین تحلیل و اقدام.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تعامل مؤثر و همکارانه با دیگران</h3>
        <p className="text-gray-800 leading-7">
          ایجاد روابط کاری مثبت با همکاران با تیپ‌های رفتاری مختلف، از جمله High D  و High I .
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. مدیریت استرس و حفظ آرامش</h3>
        <p className="text-gray-800 leading-7">
          حفظ تعادل هیجانی و استفاده از روش‌های آرامش‌بخش مانند تنفس عمیق، مدیتیشن یا ورزش.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          یک مدیر پروژه  CS که روی یک پروژه بزرگ کار می‌کند:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>با دقت برنامه‌ریزی می‌کند،</li>
          <li>جلسات منظم با تیم دارد،</li>
          <li>اما همزمان یاد می‌گیرد در موقعیت‌های حساس سریع‌تر تصمیم بگیرد،</li>
        </ul>
        <p className="text-gray-800 leading-7">
          و از همکاران پرانرژی‌تر برای تسریع کار بهره می‌برد.
          این تعادل باعث موفقیت پروژه و رضایت تیم می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ CS"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی  CS می‌توانند با تمرین‌های خاص و تغییرات آگاهانه، عملکرد خود را بهبود بخشیده و چالش‌های رفتاری‌شان را کاهش دهند. در ادامه راهکارهای کلیدی برای تعدیل و تقویت این تیپ رفتاری آمده است:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. تعدیل وسواس در جزئیات</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>یاد بگیرید چه زمان باید به جزئیات دقت کنید و کی باید از آن‌ها صرف‌نظر کنید.</li>
          <li>تمرین کنید به جای وسواس، به اجرای به موقع و مناسب اولویت دهید.</li>
          <li>برای این منظور می‌توانید از روش «قانون 80/20»  80 درصد نتایج با 20 درصد تلاش  استفاده کنید.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تقویت مهارت تصمیم‌گیری سریع‌تر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تعیین ضرب‌الاجل‌های مشخص برای تصمیم‌گیری‌ها.</li>
          <li>تمرین «گرفتن تصمیم‌های کوچک» به سرعت برای تقویت اعتماد به نفس.</li>
          <li>بهره‌گیری از مشورت با تیپ‌های رفتاری سریع‌تر  مثل High D  برای متعادل کردن سرعت عمل.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. افزایش مهارت‌های ارتباطی و ابراز احساسات</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تمرین بیان نظرات و احساسات خود به صورت روشن و مؤثر.</li>
          <li>استفاده از کلمات مثبت و کم کردن بیان وسواس‌گونه یا انتقادی.</li>
          <li>تمرین گوش دادن فعال و بیان همدلی به دیگران.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تمرین پذیرش تغییرات و انعطاف‌پذیری</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>مواجهه تدریجی با تغییرات کوچک و تمرین سازگاری با آن‌ها.</li>
          <li>یادگیری تکنیک‌های مدیریت استرس و اضطراب مرتبط با تغییر.</li>
          <li>قبول این نکته که تغییر بخشی از رشد و موفقیت است.</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تقویت مدیریت زمان و اولویت‌بندی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>استفاده از ابزارها و تکنیک‌های مدیریت زمان مثل «ماتریس آیزنهاور».</li>
          <li>تعیین اولویت‌های روزانه و پیگیری منظم آن‌ها.</li>
          <li>جلوگیری از چندوظیفه‌گی غیرضروری که تمرکز را کاهش می‌دهد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. توسعه مهارت‌های رهبری و کار تیمی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>یادگیری روش‌های مؤثر مدیریت تیم و مشارکت دیگران در تصمیم‌ها.</li>
          <li>تقویت مهارت‌های انگیزشی برای افزایش همکاری و همراهی تیم.</li>
          <li>اعتماد به اعضای تیم و واگذاری مسئولیت‌ها.</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فردی با الگوی  CS که مدیر تیم پروژه است، با کمک این تمرینات یاد می‌گیرد:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>به جای وسواس در همه جزئیات، برخی کارها را به اعضای تیم بسپارد،</li>
          <li>در مواقع ضروری سریع تصمیم بگیرد،</li>
          <li>و در جلسات بیشتر مشارکت کند تا تیم احساس حمایت و هماهنگی بیشتری داشته باشد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی CS"
      >
        <p className="text-gray-800 leading-7">
          افراد  CS با به‌کارگیری مجموعه‌ای از دانش‌ها و مهارت‌ها می‌توانند نقاط قوت خود را تقویت کرده و بر چالش‌های رفتاری‌شان غلبه کنند. در ادامه به مهم‌ترین مهارت‌ها و دانش‌های مورد نیاز اشاره می‌کنیم:
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. مدیریت زمان و برنامه‌ریزی مؤثر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>توانایی تعیین اولویت‌ها و تخصیص منابع به شکل بهینه</li>
          <li>استفاده از ابزارهای مدیریت زمان مانند تقویم، لیست کارها و ماتریس آیزنهاور</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. تصمیم‌گیری منطقی و سریع</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>آموزش تکنیک‌های تصمیم‌گیری مانند تحلیل SWOT، ماتریس تصمیم‌گیری</li>
          <li>تمرین «تصمیم‌گیری مرحله‌ای» و محدود کردن وسواس</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. ارتباطات مؤثر و مهارت‌های بین‌فردی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>یادگیری بیان شفاف و محترمانه نظرات</li>
          <li>تمرین گوش دادن فعال و ایجاد همدلی</li>
          <li>مهارت مذاکره و مدیریت تعارض</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. مدیریت استرس و مهارت‌های خودمراقبتی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تکنیک‌های تنفس عمیق، مدیتیشن و آرام‌سازی ذهن</li>
          <li>تنظیم تعادل بین کار و زندگی</li>
          <li>شناخت و مدیریت علائم استرس</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. انعطاف‌پذیری و پذیرش تغییر</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>آموزش پذیرش تدریجی تغییرات و توسعه نگرش مثبت نسبت به نوآوری</li>
          <li>تمرین مواجهه با موقعیت‌های جدید در محیط‌های کنترل شده</li>
        </ul>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>6. رهبری و کار تیمی</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>مهارت‌های رهبری خدمتگزار و مشارکتی</li>
          <li>ایجاد انگیزه و همراهی اعضای تیم</li>
          <li>توانایی واگذاری مسئولیت و اعتمادسازی</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="دانش و مهارت‌های مورد نیاز الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>7. مهارت‌های فنی و تخصصی مرتبط با حوزه کاری</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>تقویت دانش تخصصی برای افزایش اعتماد به نفس و اثربخشی</li>
          <li>به‌روزرسانی مداوم اطلاعات و مهارت‌ها</li>
        </ul>
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          یک فرد  CS که در بخش مالی فعالیت دارد، با یادگیری مهارت‌های مدیریت استرس و ارتباط مؤثر، توانسته است در جلسات کاری به‌جای خجالت و سکوت، به شکل موثر و با اعتماد به نفس مشارکت کند و به بهبود روابط تیمی کمک نماید.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی CS"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  CS به دلیل دقت، نظم، مسئولیت‌پذیری و توجه به جزئیات، در مشاغلی که نیازمند تحلیل دقیق، مستندسازی کامل و حفظ استانداردهای کیفی هستند، بسیار موفق عمل می‌کنند. این افراد در محیط‌هایی با قوانین روشن، روندهای قابل پیش‌بینی و فرصت برای تمرکز بر کیفیت، بهترین عملکرد را دارند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>ویژگی‌های محیط کاری مناسب:</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>قوانین و استانداردهای مشخص</li>
          <li>محیط کم تنش و پیش‌بینی‌پذیر</li>
          <li>فرصت برای کار دقیق و کیفی</li>
          <li>زمان کافی برای برنامه‌ریزی و تحلیل</li>
          <li>همکاری با تیم‌های منظم و هماهنگ</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>حسابدار</h3>
        <p className="text-gray-800 leading-7">
          وظیفه مدیریت دقیق اسناد مالی، تهیه گزارش‌های کامل و اطمینان از صحت اطلاعات مالی، کاملاً با دقت و نظم افراد  CS همخوانی دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>تحلیلگر داده</h3>
        <p className="text-gray-800 leading-7">
          بررسی دقیق داده‌ها، استخراج نتایج و ارائه گزارش‌های مستند کاری است که نیاز به تفکر ساختاریافته و توجه بالا به جزئیات دارد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>مدیر کنترل کیفیت</h3>
        <p className="text-gray-800 leading-7">
          مسئولیت تضمین کیفیت محصولات و خدمات، انجام بازرسی‌های دقیق و پیروی از استانداردها، بسیار مناسب تیپ  CS است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>برنامه‌نویس</h3>
        <p className="text-gray-800 leading-7">
          نوشتن کدهای دقیق و مستند، رفع اشکال و تست نرم‌افزارها از فعالیت‌هایی است که دقت و نظم خاص این افراد را می‌طلبد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>کارشناس امور مالی</h3>
        <p className="text-gray-800 leading-7">
          مدیریت منابع مالی و بودجه‌بندی با دقت بالا و توجه به جزئیات، به مهارت‌های ذاتی این افراد می‌خورد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>آرشیو‌دار</h3>
        <p className="text-gray-800 leading-7">
          سازمان‌دهی اسناد، مدیریت پرونده‌ها و حفظ اطلاعات دقیق، کاری است که نیاز به نظم و ساختار بالایی دارد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>متخصص تضمین کیفیت</h3>
        <p className="text-gray-800 leading-7">
          طراحی و اجرای فرایندهای تضمین کیفیت و بازرسی مستمر، نیازمند دقت و تعهد این تیپ شخصیتی است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>مدیر پروژه</h3>
        <p className="text-gray-800 leading-7">
          برنامه‌ریزی دقیق پروژه‌ها، نظارت بر پیشرفت و مستندسازی مراحل مختلف، کارهایی است که با شخصیت  CS سازگار است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>پژوهشگر</h3>
        <p className="text-gray-800 leading-7">
          جمع‌آوری داده‌های علمی، تحلیل نتایج و نگارش گزارش‌های پژوهشی، مناسب کسانی است که علاقه‌مند به تحلیل و کار دقیق هستند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="مشاغل مناسب برای افراد با الگوی CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>کارشناس منابع انسانی</h3>
        <p className="text-gray-800 leading-7">
          مستندسازی فرآیندهای استخدام، آموزش و پیگیری قوانین کاری، حوزه‌ای است که افراد  CS می‌توانند در آن موفق باشند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>دستیار اداری</h3>
        <p className="text-gray-800 leading-7">
          نظم‌دهی به کارهای روزمره، مدیریت جلسات و پیگیری امور دفتری، کارهایی است که با شخصیت مسئولیت‌پذیر و منظم  CS هماهنگ است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="همسر مناسب و نحوه ارتباط مؤثر با او"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری  CS  وظیفه‌گرا و ثبات‌گرا  در روابط عاطفی و زناشویی به دنبال ثبات، احترام، امنیت و وفاداری هستند. به همین دلیل همسری که بتواند این نیازها را درک کرده و با ویژگی‌های رفتاری آن‌ها همسو باشد، برای این افراد بسیار مناسب خواهد بود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های شخصیتی مناسب همسر فرد CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. صبور و آرام:</h3>
        <p className="text-gray-800 leading-7">
          همسری که بتواند به آرامی و بدون فشار به رفتار دقیق و محتاطانه فرد  CS احترام بگذارد و به آن‌ها فضا بدهد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. منظم و قابل اعتماد:</h3>
        <p className="text-gray-800 leading-7">
          فردی که برای نظم و برنامه‌ریزی ارزش قائل باشد و به تعهدات خود پایبند باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. بیانگر و حمایتگر:</h3>
        <p className="text-gray-800 leading-7">
          کسی که بتواند احساسات و نیازهای خود را با شفافیت بیان کند و از همسر  CS حمایت و پشتیبانی کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های شخصیتی مناسب همسر فرد CS"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. با حوصله در حل اختلافات:</h3>
        <p className="text-gray-800 leading-7">
          همسری که تعارضات را با آرامش، شنیدن و منطق حل کند و عجولانه برخورد نکند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. وفادار و متعهد:</h3>
        <p className="text-gray-800 leading-7">
          وفاداری و حفظ ثبات در رابطه برای افراد  CS بسیار ارزشمند است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که همسر فرد CS باید بداند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>افراد  CS ممکن است در بروز احساسات خود کمی محتاط یا کم‌حرف باشند؛ نیازمند صبر و درک عمیق همسر خود هستند.</li>
          <li>آن‌ها تمایل دارند مسائل را با تحلیل و منطق بررسی کنند و گاهی ممکن است به نظر برسد که کمتر عاطفی‌اند.</li>
          <li>دوست دارند امور زندگی و خانه داری در چارچوب و برنامه مشخصی انجام شود. بی‌نظمی و تغییرات ناگهانی آن‌ها را ناراحت می‌کند.</li>
          <li>آن‌ها نیازمند تایید و قدردانی از تلاش‌هایشان هستند؛ حتی یک تشکر ساده می‌تواند انگیزه و رضایت زیادی ایجاد کند.</li>
          <li>گاهی ممکن است حساس باشند و واکنش‌هایشان نسبت به انتقاد تند به نظر برسد، بنابراین بهتر است در بیان نقدها محتاط و همراه با همدلی باشید.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>تلاش کند بیشتر احساسات و نیازهای خود را به زبان بیاورد و از همسر خود انتظار نداشته باشد بدون گفت‌وگو آن‌ها را بفهمد.</li>
          <li>در مقابل تغییرات و شرایط جدید زندگی انعطاف‌پذیرتر باشد و کمتر مقاومت کند.</li>
          <li>یاد بگیرد که در حل مشکلات و اختلافات به جای تحلیل زیاد، بعضی مواقع با آرامش و صمیمیت به احساسات همسرش توجه کند.</li>
          <li>سعی کند در روابط عاطفی خود فعال‌تر باشد و به رابطه‌گرایی بیشتر توجه کند.</li>
          <li>برای آرامش و پایداری رابطه، به همسر خود فرصت و فضای کافی برای ابراز وجود بدهد.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          مثال کاربردی:
          فرض کنید زوجی که یکی از آن‌ها الگوی  CS دارد، به دلیل دقت و وسواس در مدیریت خانه و امور روزمره گاهی با همسری که تیپ رفتاری متفاوت دارد دچار اختلاف می‌شوند. اگر همسر  CS بداند که همسرش نیاز به آزادی و تغییر دارد و از طرفی فرد  CS با کمی انعطاف و بیان بهتر احساساتش، می‌تواند یک تعادل آرام و پایدار در زندگی مشترک ایجاد کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی:
          "The Notebook"  2004
          نمایش داستانی از روابط پایدار، وفاداری، و صبر در عشق که می‌تواند به درک بهتر ویژگی‌های افراد با تیپ رفتاری  CS کمک کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین CS با فرزندان و بالعکس"
      >
        <p className="text-gray-800 leading-7">
          والدین با الگوی رفتاری  CS معمولاً والدینی منظم، مسئول و حمایتگر هستند که خواهان ثبات و امنیت در خانواده‌اند. در عین حال، آن‌ها برای حفظ آرامش و نظم در خانه اهمیت زیادی قائلند و ممکن است به دلیل دقت زیاد، انتظارات بالایی از فرزندان داشته باشند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر CS با فرزندان :"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>1. ایجاد محیط امن و منظم:</h3>
        <p className="text-gray-800 leading-7">
          فرزندان نیاز دارند در فضایی باثبات و قابل پیش‌بینی بزرگ شوند که قوانین و چارچوب‌های مشخصی داشته باشد.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>2. ابراز محبت و حمایت:</h3>
        <p className="text-gray-800 leading-7">
          والدین  CS باید به‌طور واضح احساسات مثبت خود را به فرزندان نشان دهند تا آن‌ها احساس امنیت عاطفی کنند.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>3. صبوری و گوش دادن فعال:</h3>
        <p className="text-gray-800 leading-7">
          گاهی ممکن است والدین به دلیل تمرکز بر جزئیات و نظم، گوش دادن به دغدغه‌های فرزندان را به تعویق بیندازند؛ اما باید با صبر و حوصله به حرف‌های فرزندان گوش دهند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر CS با فرزندان :"
      >
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>4. تشویق به استقلال:</h3>
        <p className="text-gray-800 leading-7">
          دادن فرصت به فرزندان برای تصمیم‌گیری و یادگیری از اشتباهات، هرچند با نظارت، برای رشد آن‌ها حیاتی است.
        </p>
        <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>5. تنظیم انتظارات منطقی:</h3>
        <p className="text-gray-800 leading-7">
          انتظار بیش از حد و سخت‌گیری زیاد ممکن است باعث استرس و دوری فرزندان شود. والدین  CS باید تعادل را در سخت‌گیری و محبت حفظ کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرزندان CS باید رعایت کنند:"
      >
        <ul className="list-disc list-inside space-y-2">
          <li>صبور باشند و درک کنند که والدین‌شان به‌خاطر محبت و مسئولیت‌پذیری، برخی اوقات سخت‌گیر به نظر می‌رسند.</li>
          <li>سعی کنند نیازهای والدین را بشناسند و در چارچوب قوانین خانواده رفتار کنند.</li>
          <li>ارتباط خود را با والدین به شکل باز و شفاف حفظ کنند و احساسات و دغدغه‌هایشان را بیان کنند.</li>
          <li>از نظم و برنامه‌ریزی والدین بهره‌مند شوند و یاد بگیرند چگونه مسئولیت‌های خود را به خوبی انجام دهند.</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="مثال کاربردی:"
      >
        <p className="text-gray-800 leading-7">
          یک والد  CS ممکن است از فرزندش انتظار داشته باشد هر شب تکالیف مدرسه‌اش را کامل انجام دهد و برنامه خواب منظمی داشته باشد. اگر فرزند به جای مقاومت، با آرامش به والدین بگوید که نیاز به کمی انعطاف دارد و دلایلش را شرح دهد، والدین راحت‌تر می‌توانند در برنامه تغییر ایجاد کنند و ارتباط بهتر برقرار شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی:"
      >
        <p className="text-gray-800 leading-7">
          "Little Miss Sunshine"  2006
          فیلمی که به روابط خانوادگی پرچالش اما پرمحبت و سازنده می‌پردازد و می‌تواند درک بهتری از تفاوت‌های رفتاری و نیازهای اعضای خانواده به ما بدهد.
        </p>
      </Page>
    </>
  )
}

export default CS
